export default "__VITE_ASSET__a492a45d__"